<template>

    <div>
      <!-- Table Container Card -->
      <b-card
        no-body
        class="mb-0"
      >
      <div class="m-2">
  <b-row>
    <b-col cols="5">
      <label>Tanggal Awal</label>
      <b-form-datepicker id="start-datepicker" v-model="startDateFilter" class="mb-2"></b-form-datepicker>
    </b-col>
    <b-col cols="5">
      <label>Tanggal Akhir</label>
      <b-form-datepicker id="end-datepicker" v-model="endDateFilter" class="mb-2"></b-form-datepicker>
    </b-col>
  </b-row>
  <!-- Table Top -->
  <b-row class="mb-3">
    <!-- Per Page -->
    <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
      <label>Show</label>
      <v-select
        v-model="perPage"
        :options="perPageOptions"
        :clearable="false"
        class="per-page-selector d-inline-block mx-50"
      />
      <label>entries</label>
    </b-col>
  </b-row>

  <!-- Total Count and Sum -->
  <b-row class="mb-3">
    <b-col cols="6" class="d-flex align-items-center justify-content-start">
      <div class="font-weight-bold h4">Total Count All: {{ totalCount }}</div>
    </b-col>
    <b-col cols="6" class="d-flex align-items-center justify-content-end">
      <div class="font-weight-bold h4">Total All: {{ formatCurrency(totalSum) }}</div>
    </b-col>
  </b-row>
</div>
        <b-table
          ref="refPurchaseOrderReceiveWarehouseTable"
          class="position-relative"
          :items="fetchPurchaseOrderSummaryReceives"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="No matching records found"
          :sort-desc.sync="isSortDirDesc"
        >
        <!-- Column: Iteration Number -->
        <template #cell(No)="data">
          <div class="text-nowrap">
            {{ data.index + 1 + (currentPage - 1) * perPage }}
          </div>
        </template>

        <!-- Column: Code -->
        <template #cell(Code)="data">
            <div class="text-nowrap">
              {{ data.item.branch_code }}
            </div>
          </template>
          <!-- Column: Description -->
          <template #cell(Description)="data">
            <div class="text-nowrap">
              <span class="align-text-top text-capitalize">{{data.item.branch_name }}</span>
            </div>
          </template>
          <template #cell(CountSupplies)="data">
      <div class="text-center">
        {{ data.item.count_supplies }}
      </div>
    </template>

    <!-- Column: TotalSupplies -->
    <template #cell(TotalSupplies)="data">
      <div class="d-flex justify-content-between">
        <span>{{ currencyCode }}</span>
        <span>{{ formatCurrency(data.item.total_supplies) }}</span>
      </div>
    </template>

    <!-- Column: CountFGS -->
    <template #cell(CountFGS)="data">
      <div class="text-center">
        {{ data.item.count_fgs }}
      </div>
    </template>

    <!-- Column: TotalFGS -->
    <template #cell(TotalFGS)="data">
      <div class="d-flex justify-content-between">
        <span>{{ currencyCode }}</span>
        <span>{{ formatCurrency(data.item.total_fgs) }}</span>
      </div>
    </template>

    <!-- Column: CountAssets -->
    <template #cell(CountAssets)="data">
      <div class="text-center">
        {{ data.item.count_assets }}
      </div>
    </template>

    <!-- Column: TotalAssets -->
    <template #cell(TotalAssets)="data">
      <div class="d-flex justify-content-between">
        <span>{{ currencyCode }}</span>
        <span>{{ formatCurrency(data.item.total_assets) }}</span>
      </div>
    </template>

    <!-- Column: CountAll -->
    <template #cell(CountAll)="data">
      <div class="text-center">
        {{ data.item.count_all }}
      </div>
    </template>

    <!-- Column: TotalAll -->
    <template #cell(TotalAll)="data">
      <div class="d-flex justify-content-between">
        <span>{{ currencyCode }}</span>
        <span>{{ formatCurrency(data.item.total_all) }}</span>
      </div>
    </template>
    <!-- Column: Action -->
    <template #cell(Action)="data">
      <b-dropdown
  variant="link"
  no-caret
  :right="$store.state.appConfig.isRTL"
>
  <template #button-content>
    <feather-icon
      icon="MoreVerticalIcon"
      size="16"
      class="align-middle text-body"
    />
  </template>

  <b-dropdown-item @click="showChart(data.item)">
    <feather-icon icon="BarChartIcon" />
    <span class="align-middle ml-50">Chart</span>
  </b-dropdown-item>

  <b-dropdown-item @click="showDetail(data.item)">
    <feather-icon icon="FileTextIcon" />
    <span class="align-middle ml-50">Details</span>
  </b-dropdown-item>
</b-dropdown>
              </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >

              <b-pagination
                v-model="currentPage"
                :total-rows="totalPurchaseOrderSummaryReceives"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
      </b-card>
    </div>
  </template>

  <script>
  import {
    BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
    BBadge, BDropdown, BDropdownItem, BPagination, BModal, VBModal, BListGroup, BListGroupItem, BFormDatepicker,
  } from 'bootstrap-vue'
  import axios from 'axios'
  import vSelect from 'vue-select'
  import store from '@/store'
  import { getUserData } from '@/auth/utils'
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
  import { ref, onUnmounted } from '@vue/composition-api'
  import { avatarText } from '@core/utils/filter'
  import moment from 'moment'
  import { VueHorizontalTimeline } from "vue-horizontal-timeline"
  import PurchaseOrderReceiveWarehouse from './Summary'

  const userRole = ''

  const messageBox = ''
  const to = ''
  const cc = ''
  const reason = ''
  const PurchaseOrderId = ''
  const currencyCode = 'RP'
  const messagesList = []
  const statusItems = []
  const items = []
  const userId = getUserData().user_id
  const modalDetailShow = false
  const modalMessage = false
  export default {
    components: {
      VueHorizontalTimeline,
      BListGroup,
      BListGroupItem,
      // PurchaseOrderesListFilters,
      BModal,
      VBModal,
      BCard,
      BRow,
      BCol,
      BFormInput,
      BButton,
      BTable,
      BMedia,
      BAvatar,
      BLink,
      BBadge,
      BDropdown,
      BDropdownItem,
      BPagination,
      BFormDatepicker,
      vSelect,
    },
    data() {
      return {
        currencyCode,
      items,
      statusItems,
      PurchaseOrderId,
      userId,
      messagesList,
      }
    },
    mounted() {
      this.userRole = this.$cookies.get('UserRole')
      this.$root.$on('refreshTable', text => {
      console.log(text) // here you need to use the arrow function
      this.$refs.refPurchaseOrderReceiveWarehouseTable.refresh()
    })
    },
    setup() {
      const BRANCH_APP_STORE_MODULE_NAME = 'app-purchase-order'
        // UnRegister on leave
        onUnmounted(() => {
          if (store.hasModule(BRANCH_APP_STORE_MODULE_NAME)) store.unregisterModule(BRANCH_APP_STORE_MODULE_NAME)
        })

      const isAddNewPurchaseOrderSidebarActive = ref(false)

      const statusOptions = [
        { label: 'Pending', value: 'pending' },
        { label: 'Active', value: 'active' },
        { label: 'Inactive', value: 'inactive' },
      ]

      const {
        fetchPurchaseOrderSummaryReceives,
        fetchRoles,
        tableColumns,
        perPage,
        currentPage,
        totalPurchaseOrderSummaryReceives,
        totalCount,
        totalSum,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refPurchaseOrderReceiveWarehouseTable,
        refetchData,

        // UI
        resolvePurchaseOrderRoleVariant,
        resolvePurchaseOrderRoleIcon,
        resolvePurchaseOrderStatusVariant,

        startDateFilter,
        endDateFilter,
        // Extra Filters
        roleFilter,
        statusFilter,
      } = PurchaseOrderReceiveWarehouse()

      const roleOptions = [
        { label: 'Admin', value: 'admin' },
        { label: 'Author', value: 'author' },
        { label: 'Editor', value: 'editor' },
        { label: 'Maintainer', value: 'maintainer' },
        { label: 'Subscriber', value: 'subscriber' },
      ]

      return {
        to,
        cc,
        reason,
        messageBox,
        modalDetailShow,
        modalMessage,
        // Sidebar
        isAddNewPurchaseOrderSidebarActive,
        userRole,
        fetchPurchaseOrderSummaryReceives,
        fetchRoles,
        tableColumns,
        perPage,
        currentPage,
        totalPurchaseOrderSummaryReceives,
        totalCount,
        totalSum,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refPurchaseOrderReceiveWarehouseTable,
        refetchData,

        // Filter
        avatarText,

        // UI
        resolvePurchaseOrderRoleVariant,
        resolvePurchaseOrderRoleIcon,
        resolvePurchaseOrderStatusVariant,

        startDateFilter,
        endDateFilter,
        roleOptions,
        statusOptions,

        // Extra Filters
        roleFilter,
        statusFilter,
      }
    },
    methods: {
      formatCurrency(value) {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'IDR' }).format(value)
    },
        deletePurchaseOrder(id) {
          const userToken = this.$cookies.get('userToken')
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${userToken}`,
  }
            axios
                .get(`${process.env.VUE_APP_API_DELETE_MATERIAL_REQUEST}${id}`, { headers })
                .then(response => {
                  console.log(response)
                  if (response.data.success === true) {
                    this.$refs.refPurchaseOrderReceiveWarehouseTable.refresh()
                    this.$toast({
                      component: ToastificationContent,
                      position: 'top-right',
                      props: {
                        title: 'Congratulation',
                        icon: 'CoffeeIcon',
                        variant: 'success',
                        text: 'Your data has been deleted!',
                      },
                    })
                  } else {
                    this.$toast({
                      component: ToastificationContent,
                      position: 'top-right',
                      props: {
                        title: 'Notification',
                        icon: 'BellIcon',
                        variant: 'danger',
                        text: 'Something went wrong',
                      },
                    })
                  }
                })
                .catch(err => {
                    console.log(err)
                })
        },
        editPurchaseOrder(data) {
            this.$cookies.set('PurchaseOrderEdit', data)
            this.$router.push({ name: 'apps-purchase-order-edit' })
        },
        confirmPurchaseOrder(id) {
          const userToken = this.$cookies.get('userToken')
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${userToken}`,
  }
          const body = {
          time: moment(),
          }
      axios
        .post(`${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_CONFIRM_PURCHASE_ORDER}/${id}`, body, { headers })
        .then(async response => {
          if (response.data.success === true) {
            this.$refs.refPurchaseOrderReceiveWarehouseTable.refresh()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Confirm Purchase OrderSuccess',
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
          } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Something went wrong',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
          }
          })
        },
        sendPurchaseOrder(data) {
            this.$cookies.set('PurchaseOrderSend', data)
            this.$router.push({ name: 'apps-purchase-order-send' })
        },
        showChart(item) {
    localStorage.setItem('SummaryData', JSON.stringify(item))
          this.$router.push({ name: 'apps-procurement-purchase-order-list-summary-chart' })
        },
      addNew() {
            this.$router.push({ name: 'apps-material-request-receive-add' })
      },
      dateSimple(value, format = 'YYYY-MM-DD') {
          let dateRet = ''
          if (value !== null) {
            dateRet = moment(String(value)).format(format)
          } else { dateRet = null }
          return dateRet
      },
      showDetail(item) {
      localStorage.setItem('SummaryData', JSON.stringify(item))
      this.$router.push({ name: 'apps-procurement-purchase-order-list-summary-details' })
      },
      hasPermission(permission) {
        const permissions = this.$cookies.get('userPermissions').split(',')
        return permissions.includes(permission) ? true : false
      },
      async receivePurchasingPurchaseOrder(item) {
        this.$cookies.set('PurchaseOrderDetail', item)
        this.$router.push({ name: 'apps-purchase-order-receive-purchasing' })
      },
      async receiveWarehousePurchaseOrder(item) {
        this.$cookies.set('PurchaseOrderDetail', item)
        this.$router.push({ name: 'apps-purchase-order-receive-warehouse' })
      },
      confirmPurchaseOrderByLabManager(id) {
        const userToken = this.$cookies.get('userToken')
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${userToken}`,
  }
          const userData = this.$cookies.get('userData')
          if (userData.user_signature !== null) {
          const body = {
          time: moment(),
          }
      axios
        .post(`${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_CONFIRM_PURCHASE_ORDER_CENTER}/laboratory_manager/${id}`, body, { headers })
        .then(async response => {
          if (response.data.success === true) {
            this.$refs.refPurchaseOrderReceiveWarehouseTable.refresh()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Confirm Purchase OrderSuccess',
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
          } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Something went wrong',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
          }
          })
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'You have to upload your Signature First!',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        }
      },
      confirmPurchaseOrderByRegionalManager(id) {
        const userToken = this.$cookies.get('userToken')
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${userToken}`,
  }
          const body = {
          time: moment(),
          }
      axios
        .post(`${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_CONFIRM_PURCHASE_ORDER_CENTER}/regional_manager/${id}`, body, { headers })
        .then(async response => {
          if (response.data.success === true) {
            this.$refs.refPurchaseOrderReceiveWarehouseTable.refresh()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Confirm Purchase OrderSuccess',
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
          } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Something went wrong',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
          }
          })
      },
      confirmPurchaseOrderByDivisionHead(id) {
        const userToken = this.$cookies.get('userToken')
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${userToken}`,
  }
          const body = {
          time: moment(),
          }
      axios
        .post(`${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_CONFIRM_PURCHASE_ORDER_CENTER}/division_head/${id}`, body, { headers })
        .then(async response => {
          if (response.data.success === true) {
            this.$refs.refPurchaseOrderReceiveWarehouseTable.refresh()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Confirm Purchase OrderSuccess',
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
          } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Something went wrong',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
          }
          })
      },
      confirmPurchaseOrderByFACoalManager(id) {
        const userToken = this.$cookies.get('userToken')
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${userToken}`,
  }
          const body = {
          time: moment(),
          }
      axios
        .post(`${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_CONFIRM_PURCHASE_ORDER_CENTER}/fa_coal_manager/${id}`, body, { headers })
        .then(async response => {
          if (response.data.success === true) {
            this.$refs.refPurchaseOrderReceiveWarehouseTable.refresh()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Confirm Purchase OrderSuccess',
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
          } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Something went wrong',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
          }
          })
      },
      confirmPurchaseOrderByOperationDirector(id) {
        const userToken = this.$cookies.get('userToken')
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${userToken}`,
  }
        const userData = this.$cookies.get('userData')
          if (userData.user_signature !== null) {
          const body = {
          time: moment(),
          }
      axios
        .post(`${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_CONFIRM_PURCHASE_ORDER_CENTER}/operation_director/${id}`, body, { headers })
        .then(async response => {
          if (response.data.success === true) {
            this.$refs.refPurchaseOrderReceiveWarehouseTable.refresh()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Confirm Purchase OrderSuccess',
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
          } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Something went wrong',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
          }
          })
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'You have to upload your Signature First!',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        }
      },
      confirmPurchaseOrderByVicePresident(id) {
        const userToken = this.$cookies.get('userToken')
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${userToken}`,
  }
        const userData = this.$cookies.get('userData')
          if (userData.user_signature !== null) {
          const body = {
          time: moment(),
          }
      axios
        .post(`${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_CONFIRM_PURCHASE_ORDER_CENTER}/vice_president/${id}`, body, { headers })
        .then(async response => {
          if (response.data.success === true) {
            this.$refs.refPurchaseOrderReceiveWarehouseTable.refresh()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Confirm Purchase OrderSuccess',
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
          } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Something went wrong',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
          }
          })
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'You have to upload your Signature First!',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        }
      },
      confirmPurchaseOrderByPresidentDirector(id) {
        const userToken = this.$cookies.get('userToken')
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${userToken}`,
  }
        const userData = this.$cookies.get('userData')
          if (userData.user_signature !== null) {
          const body = {
          time: moment(),
          }
      axios
        .post(`${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_CONFIRM_PURCHASE_ORDER_CENTER}/president_director/${id}`, body, { headers })
        .then(async response => {
          if (response.data.success === true) {
            this.$refs.refPurchaseOrderReceiveWarehouseTable.refresh()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Confirm Purchase OrderSuccess',
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
          } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Something went wrong',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
          }
          })
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'You have to upload your Signature First!',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        }
      },
      confirmPurchaseOrderByProcurementPusat(id) {
        const userToken = this.$cookies.get('userToken')
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${userToken}`,
  }
          const body = {
          time: moment(),
          }
      axios
        .post(`${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_CONFIRM_PURCHASE_ORDER_CENTER}/procurement_pusat/${id}`, body, { headers })
        .then(async response => {
          if (response.data.success === true) {
            this.$refs.refPurchaseOrderReceiveWarehouseTable.refresh()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Confirm Purchase OrderSuccess',
                icon: 'CheckIcon',
                variant: 'success',
              },
            })
          } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Something went wrong',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
          }
          })
      },
      async sendMessage() {
        const userToken = this.$cookies.get('userToken')
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${userToken}`,
  }
        const id = this.PurchaseOrderId
        const Message = this.messageBox
        const body = {
          purchase_order_chat_purchase_order_id: id,
          purchase_order_chat_text: Message,
          time: moment(),
        }
      axios
        .post(`${process.env.VUE_APP_API_CREATE_MATERIAL_REQUEST_CHATS}`, body, { headers })
        .then(async response => {
          if (response.data.success === true) {
            this.messageBox = ''
      axios
        .get(`${process.env.VUE_APP_API_GET_MATERIAL_REQUEST_CHATS}${id}`, { headers })
        .then(response2 => {
          if (response2.data.success === true) {
            console.log('Fetching Data')
        if (response2.data.data) {
        messagesList.splice(0, messagesList.length)
          response2.data.data.map(value => {
            messagesList.push(value)
            return value.invoiceMessage
          })
        }
          }
          })
          } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Something went wrong',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
          }
          })
      },
    },
  }
  </script>

  <style lang="scss" scoped>
  .per-page-selector {
    width: 90px;
  }
  </style>

  <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  </style>
